import { render } from "./CSATDialogSimulado.vue?vue&type=template&id=88cb2558&scoped=true"
import script from "./CSATDialogSimulado.vue?vue&type=script&lang=js"
export * from "./CSATDialogSimulado.vue?vue&type=script&lang=js"

import "./CSATDialogSimulado.vue?vue&type=style&index=0&id=88cb2558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cb2558"]])

export default __exports__